import { render, staticRenderFns } from "./WebInfo.vue?vue&type=template&id=fffc0bce&"
import script from "./WebInfo.vue?vue&type=script&lang=js&"
export * from "./WebInfo.vue?vue&type=script&lang=js&"
import style0 from "./WebInfo.vue?vue&type=style&index=0&id=fffc0bce&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports